import React from 'react';
import { Card } from 'react-bootstrap';

const SummaryPanel = ({ 
  currentStep, 
  steps, 
  formData, 
  equipmentItems,
  maintenanceHistory,
  upcomingEvents, 
  systemInteractions,
  pastIssues
}) => {
  // Don't render for the first step (venue profile) or results
  if (currentStep === 0 || steps[currentStep] === 'results') return null;

  return (
    <Card 
      className="mb-4 summary-panel"
      style={{
        backgroundColor: 'rgba(75, 40, 120, 0.2)',
        borderRadius: '12px',
        backdropFilter: 'blur(5px)',
        WebkitBackdropFilter: 'blur(15px)',
        maxHeight: '70vh',
      }}
    >
      <Card.Body style={{ 
        overflowY: 'auto',
        background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05))'
      }}>
        <div className="mb-3">
          <h5 style={{ color: '#ffffff', fontWeight: '600', margin: 0, textAlign: 'center', textShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>Summary</h5>
        </div>
        
        {formData['venue-profile'] && (
          <div className="mb-3">
            <h6 style={{ color: '#d9d9d9', fontSize: '0.9rem' }}>Venue Profile</h6>
            <p style={{ fontSize: '0.85rem', margin: 0, color: '#d9d9d9' }}>
              {formData['venue-profile'].venueName} ({formData['venue-profile'].venueType}) - 
              Capacity: {formData['venue-profile'].capacity}
            </p>
          </div>
        )}
        
        {equipmentItems.length > 0 && (
          <div className="mb-3">
            <h6 style={{ color: '#d9d9d9', fontSize: '0.9rem' }}>Equipment Items</h6>
            <p style={{ fontSize: '0.85rem', margin: 0, color: '#d9d9d9' }}>
              {equipmentItems.length} items added
            </p>
          </div>
        )}
        
        {maintenanceHistory.length > 0 && (
          <div className="mb-3">
            <h6 style={{ color: '#d9d9d9', fontSize: '0.9rem' }}>Maintenance History</h6>
            <p style={{ fontSize: '0.85rem', margin: 0, color: '#d9d9d9' }}>
              {maintenanceHistory.length} records added
            </p>
          </div>
        )}
        
        {upcomingEvents.length > 0 && (
          <div className="mb-3">
            <h6 style={{ color: '#d9d9d9', fontSize: '0.9rem' }}>Upcoming Events</h6>
            <p style={{ fontSize: '0.85rem', margin: 0, color: '#d9d9d9' }}>
              {upcomingEvents.length} events added
            </p>
          </div>
        )}
        
        {systemInteractions.length > 0 && (
          <div className="mb-3">
            <h6 style={{ color: '#d9d9d9', fontSize: '0.9rem' }}>System Interactions</h6>
            <p style={{ fontSize: '0.85rem', margin: 0, color: '#d9d9d9' }}>
              {systemInteractions.length} interactions added
            </p>
          </div>
        )}
        
        {pastIssues.length > 0 && (
          <div className="mb-3">
            <h6 style={{ color: '#d9d9d9', fontSize: '0.9rem' }}>Past Issues</h6>
            <p style={{ fontSize: '0.85rem', margin: 0, color: '#d9d9d9' }}>
              {pastIssues.length} issues added
            </p>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default SummaryPanel;